// import { humanisetime } from "../utils/formatters";
// import moment from "moment";

function NasInfo({ nasStatus, nasPercent }) {
  // const nasStatusIndicator = () => {
  //   const percent = nasPercent;
  //   if (percent > 99) {
  //     return "online";
  //   } else if (percent > 95) {
  //     return "slow";
  //   }
  //   return "defective";
  // };

  const getNasStatus = () => {
    if (nasPercent > 98) {
      return "super-green";
    } else if (nasPercent > 95) {
      return "green";
    } else if (nasPercent > 90) {
      return "amber";
    } else {
      return "red";
    }
  };

  const showNasStatus = () => {
   if (!nasStatus?.contentDownloaded || !nasStatus?.s3_count) return <div className="kpi-value">-</div>
   return  <div className="kpi-value">{nasPercent}%</div>
  }

  return (
    <>
      <div className={`status-label ${getNasStatus()}`}>
        <i className="fa fa-server"></i> NAS ({nasStatus ? 1 : 0})
      </div>
      <div className="flex-row">
        <div className="cell remove-pointer">
           {showNasStatus()}
          <div className="kpi-label action-text nas-off">Resources</div>
        </div>
      </div>
      <div className="arrow">&nbsp;</div>
    </>
  );
}

export default NasInfo;
